
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import type { ArticleFormValues } from "./ArticleEditor";
import { Control } from "react-hook-form";

interface Props {
  control: Control<ArticleFormValues>;
  publicationState: string;
  setPublicationState: (state: string) => void;
}

const getPublicationStateLabel = (state: string) => {
  switch (state) {
    case 'published': return 'Published';
    case 'archived': return 'Archived';
    default: return 'Draft';
  }
};

export default function ArticleEditorPublicationState({
  control, publicationState, setPublicationState
}: Props) {
  return (
    <FormField
      control={control}
      name="publication_state"
      rules={{ required: "Publication state is required" }}
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel className="text-white/90">Publication State</FormLabel>
          <FormControl>
            <div>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    className="w-full flex justify-between border-white/20 bg-black/20"
                  >
                    {getPublicationStateLabel(publicationState)}
                    <ChevronDown className="h-4 w-4 ml-2" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-56">
                  <DropdownMenuItem onClick={() => {
                    setPublicationState("draft");
                    field.onChange("draft");
                  }}>
                    Draft
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => {
                    setPublicationState("published");
                    field.onChange("published");
                  }}>
                    Published
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => {
                    setPublicationState("archived");
                    field.onChange("archived");
                  }}>
                    Archived
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
